<template>
    <div class="d-flex justify-content-center align-items-center outside-class p-1 ps-2 pe-2">
        <slot />
    </div>
</template>

<script>
export default {
    name: "GreyButton"
}
</script>

<style scoped>
.outside-class {
    border-radius: 50px;
    background-color: #f8f8f8;
}
</style>
